const SCHEDULED_FOR_MAILING = {
  now: "now",
  later: "later",
};

Object.freeze(SCHEDULED_FOR_MAILING);

export { SCHEDULED_FOR_MAILING };
